import { render } from "./CIS-Image-Carousel.vue?vue&type=template&id=a97f2544"
import script from "./CIS-Image-Carousel.vue?vue&type=script&lang=js"
export * from "./CIS-Image-Carousel.vue?vue&type=script&lang=js"

import "./CIS-Image-Carousel.vue?vue&type=style&index=0&id=a97f2544&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__